import React from 'react';
import { css } from 'emotion';

import { ToggleProps } from './Toggle.props';

import './styles/base_styles.scss';

const defaultSizes = {
  height: 16,
  width: 32,
  sliderDiameter: 12,
};

const Toggle = ({
  children,
  className = '',
  isOn,
  onToggle,
  id,
  sizes = defaultSizes,
}: ToggleProps): JSX.Element => {
  const { height, width, sliderDiameter } = sizes;
  const left = (height - sliderDiameter) / 2;
  const translationAmount = width - height;
  const styles = {
    toggle: {
      height: `${height}px`,
      width: `${width}px`,
    },
    slider: {
      borderRadius: `${height}px`,
      '&:before': {
        height: `${sliderDiameter}px`,
        left: `${left}px`,
        width: `${sliderDiameter}px`,
      }
    },
    input: { // equivalent to selector 'input:checked + .bf-toggle--slider:before {}'
      '&:checked + .bf-toggle--slider:before': {
        transform: `translate(${translationAmount}px, 50%)`
      }
    },
  };

  return (
    <label
      className={`bf-toggle ${className} ${css(styles.toggle)}`}
      data-testid="toggle-label"
    >
      <input
        checked={isOn}
        className={`bf-toggle--input ${css(styles.input)}`}
        data-testid="toggle-input"
        onChange={onToggle}
        type="checkbox"
        id={id}
      />
      <span className={`bf-toggle--slider ${css(styles.slider)}`} />
      {children}
    </label>
  );
};

export default Toggle;
